<template>
  <div>
    <div>nihao1滴滴滴</div>
  </div>
</template>

<script>
export default {
  name: 'LineChartLable',
}
</script>

<style></style>
